import { render, staticRenderFns } from "./FormColorCliente.vue?vue&type=template&id=1dc36a6a"
import script from "./FormColorCliente.vue?vue&type=script&lang=js"
export * from "./FormColorCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports